import { authentication } from '@ecosystem/newron-client-lib';
import axios from 'axios';
import { clientToImpersonate } from './impersonate';
import { SimpleMessageError } from '../design/error/simpleMessageError';

const USERS_API_URL = '/api/users-api/v1/users';

type Response = {
  // If user is member of user groups that is superset of user groups current client user is part of
  // E.g. user A has groups [A,B]; user B has groups [A,B,C]; user C has groups [A,C] => User B has same access; User C not
  sameAccessUsers: User[];

  // Other users of the same client
  otherClientUsers: User[];
};

type User = {
  userId: string;
  email: string;
  givenName: string;
  familyName: string;
};

const DEFAULT_ERROR_MESSAGE = 'Failed to load client users';

async function getUsersByAccess(): Promise<Response> {
  const token = await authentication.getAccessToken();
  try {
    const response = await axios.get<Response>(`${USERS_API_URL}/users-by-access`, {
      headers: {
        Authorization: `Bearer ${token}`,
        ...(await clientToImpersonate()),
      },
    });
    if (!response.data) {
      throw new SimpleMessageError(DEFAULT_ERROR_MESSAGE);
    }
    return response.data;
  } catch (err) {
    throw new SimpleMessageError(err?.response?.data || DEFAULT_ERROR_MESSAGE);
  }
}

async function getSameAccessUsers(): Promise<User[]> {
  const usersByAccess = await getUsersByAccess();
  return usersByAccess.sameAccessUsers;
}

export const userClient = {
  getSameAccessUsers,
};
